import {
  DEFAULT_SHOW_BUTTON_SUBMIT,
  DISABLED_BUTTON_SUBMIT,
  instance2,
  TYPE_INSTANCE2,
} from "App/constants";
import { InputTextMaster, MasterButton, Modal } from "App/Component/ui";
import { Grid } from "@material-ui/core";
import { useState } from "react";
import {
  defaultToastError,
  defaultToastSuccess,
  fetchData,
  titleModal,
} from "App/utils/helpers";
import { LIST_URL_MASTER } from "utils/masters";

export const RESET_STATE_TIPE_REGISTRASI = {
  id: "",
  code: "",
  title: "",
  remark: "-",
};

export const deleteTipeRegistrasiById = async (
  id,
  setRows,
  setShowModalDeleteConfirm,
  setFormData
) => {
  try {
    await instance2.post(
      LIST_URL_MASTER.tipe_registrasi.delete,
      {},
      {
        headers: {
          idregistrationtype: id,
        },
      }
    );
    const newData = await fetchData(
      TYPE_INSTANCE2,
      LIST_URL_MASTER.tipe_registrasi.list
    );
    setRows(newData);
    setShowModalDeleteConfirm(false);
    setFormData(RESET_STATE_TIPE_REGISTRASI);
    return defaultToastSuccess("Data berhasil dihapus");
  } catch (error) {
    return defaultToastError(error?.response?.data?.message);
  }
};

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "center",
  },
  {
    id: "code",
    disablePadding: false,
    label: "KODE",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "title",
    disablePadding: false,
    label: "JUDUL",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "remark",
    disablePadding: false,
    label: "REMARK",
    align: "left",
    sort: false,
    minWidth: "150px",
  },
  {
    id: "inserted_time",
    disablePadding: false,
    label: "INSERTED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "inserted_by",
    disablePadding: false,
    label: "INSERTED BY",
    sort: false,
    minWidth: "150px",
  },
  {
    id: "updated_time",
    disablePadding: false,
    label: "UPDATED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "updated_by",
    disablePadding: false,
    label: "UPDATED BY",
    sort: false,
    minWidth: "150px",
  },
];

export const ModalForm = ({ setShowModal, setRows, formData, setFormData }) => {
  const [disabled, setDisabled] = useState(DEFAULT_SHOW_BUTTON_SUBMIT);

  const updateTipeRegistrasi = () => {
    return instance2.post(
      LIST_URL_MASTER.tipe_registrasi.update,
      {
        ...formData,
      },
      {
        headers: {
          idregistrationtype: formData.id,
        },
      }
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisabled(DISABLED_BUTTON_SUBMIT);
    if (formData.code === "") {
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
      defaultToastError("Kode tidak boleh kosong");
    } else {
      try {
        if (formData.id !== "") {
          await updateTipeRegistrasi();
          const newData = await fetchData(
            TYPE_INSTANCE2,
            LIST_URL_MASTER.tipe_registrasi.list
          );
          setRows(newData);
          setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
          setShowModal(false);
        }
      } catch (error) {
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
        defaultToastError(error?.response?.data?.message);
      }
    }
  };

  const handleChange = (text) => (e) => {
    setFormData({
      ...formData,
      [text]: e.target.value,
    });
  };

  return (
    <Modal
      title={`${titleModal(formData.id)} Tipe Registrasi`}
      show={setShowModal}>
      <form action='POST' onSubmit={(e) => handleSubmit(e)}>
        <Grid container spacing={1}>
          <InputTextMaster
            type='hidden'
            name='id'
            id='id'
            readOnly={true}
            value={formData.id}
          />
          <Grid item sm={12}>
            <InputTextMaster
              name='code'
              label='Kode'
              id='code'
              disabled={true}
              readOnly={true}
              value={formData.code}
              placeholder='Kode'
            />
          </Grid>

          <Grid item sm={12}>
            <InputTextMaster
              name='title'
              label='Judul'
              id='title'
              value={formData.title}
              onChange={handleChange("title")}
              placeholder='Judul'
            />
          </Grid>

          <Grid item sm={12}>
            <InputTextMaster
              name='remark'
              label='Remark'
              id='remark'
              value={formData.remark}
              onChange={handleChange("remark")}
              placeholder='Remark'
            />
          </Grid>
        </Grid>
        <Grid
          container
          direction='row'
          justifyContent='flex-end'
          alignItems='center'>
          <MasterButton
            className={"mt-1"}
            type='submit'
            color={disabled.color}
            name={disabled.label}
            size='md'
          />
        </Grid>
      </form>
    </Modal>
  );
};
